import React, { useEffect, useState } from "react";
import { searchCustomerInfoList } from "../../../../http/api/CustomerAPI";
import CommonAutocomplete from "../../../../components/CommonAutocomplete";
import { fromKana } from "hepburn";
import { convertToHiragana } from "../../../../utils/convertToHalfWidthKana";
import { MODAL_STATE } from "../../../chain_store/ChainStoreUtils";

export const CustomerAutocomplete = (props) => {
  const { customer, setCustomer, modalState } = props;
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    // if (modalState.Value.mode === MODAL_STATE.INSERT) return;
    const customerId =
      modalState.Value?.updateElement?.customerId || modalState.customerId;
    const newCustomer = customers.find((c) => c.customerId === customerId);
    setCustomer(newCustomer);
  }, [modalState.Value.updateElement, customers]);

  async function GetCustomer() {
    try {
      let response = await searchCustomerInfoList({});
      let listCustomer = response.listCustomerInfo;
      listCustomer = listCustomer
        .filter((x) => x.customerName != null)
        .map((c) => ({
          ...c,
          customerNameHira: convertToHiragana(c.customerNameFurigana || ""),
          customerNameRomanji: fromKana(c.customerNameFurigana || ""),
        }))
        .sort((a, b) => a.customerId - b.customerId);
      setCustomers(listCustomer);
      console.log("取引先リスト取得");
    } catch (e) {
      console.log("取引先リストを取得する際にエラー発生した：", e);
    }
  }
  useEffect(() => {
    GetCustomer();
  }, []);
  return (
    <div>
      <CommonAutocomplete
        label="取引先"
        value={customer || null}
        onSelect={(e, newValue) => {
          setCustomer(newValue);
        }}
        data={customers}
        filterOptions={(options, { inputValue }) => {
          inputValue = fromKana(inputValue.toUpperCase());
          return options.filter(
            (x) =>
              x.customerId.toString().startsWith(inputValue) ||
              x.customerName.includes(inputValue) ||
              x.customerNameRomanji.includes(inputValue)
          );
        }}
        optionLabel={(option) => (option ? option.customerName || "" : "")}
        width={"100%"}
        disabled={
          modalState.Value.mode === MODAL_STATE.UPDATE &&
          !modalState.Value.isAlien
        }
      />
    </div>
  );
};
